var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_879_10419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.655 28.0516C185.186 25.3281 182.309 23.4766 178.997 23.4766C174.454 23.4766 76.8461 23.4766 68.5059 23.4766L57.7465 5.43359H51.707L51.6992 5.41836C50.5742 3.26797 48.3477 1.91992 45.9207 1.91992H6.52187C2.91992 1.92031 0 4.84023 0 8.44219V34.5734L4.62773 40.2191V149.559C5.8418 150.203 7.22539 150.571 8.6957 150.571H195.372V28.0516H186.655Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.372 150.571V63.9672L200 58.3035C200 44.0125 200 33.4809 200 32.1723C200 27.3695 196.107 23.4766 191.304 23.4766H178.997C183.8 23.4766 187.693 27.3695 187.693 32.1723V150.571H195.372Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.699 5.41836L61.1479 23.4766H73.4549L64.0061 5.41836C62.8811 3.26797 60.6545 1.91992 58.2275 1.91992H45.9209C48.3475 1.92031 50.574 3.26797 51.699 5.41836V5.41836Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0312 49.608L59.6879 30.7732H51.2207C50.007 29.0803 48.041 28.0518 45.9215 28.0518H6.52187C2.91992 28.0518 0 30.9717 0 34.5736V153.218C0 158.02 3.89297 161.913 8.6957 161.913H178.998C181.176 161.913 183.162 161.107 184.688 159.783H192.277V51.8459H184.806C183.266 50.4596 181.234 49.6084 178.998 49.6084L70.0312 49.608Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.304 49.6074H178.997C183.799 49.6074 187.693 53.5004 187.693 58.3031V153.217C187.693 158.02 183.8 161.913 178.997 161.913H191.304C196.106 161.913 200 158.02 200 153.217V58.3031C200 53.5004 196.107 49.6074 191.304 49.6074V49.6074Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6994 31.5492L61.1482 49.6074H73.4553L64.0064 31.5492C62.8814 29.3988 60.6549 28.0508 58.2279 28.0508H45.9209C48.3479 28.0512 50.5744 29.3988 51.6994 31.5492Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.387 196.728L175.654 194.769L181.891 183.904L107.712 109.121L93.5335 123.3C93.4237 123.409 93.4237 123.587 93.5335 123.697C169.948 200.112 164.947 195.471 167.387 196.728V196.728Z",
    fill: "#60B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.626 177.212L110.823 106.408C110.713 106.299 110.535 106.299 110.426 106.408L105.03 111.804L170.438 177.212C175.213 181.986 175.213 189.727 170.438 194.501C169.517 195.422 168.486 196.163 167.387 196.729C171.987 199.096 177.772 198.355 181.626 194.501C186.401 189.727 186.401 181.986 181.626 177.212V177.212Z",
    fill: "#26A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.242 83.1167C50.7104 102.648 50.7104 134.316 70.242 153.848C79.8033 163.409 92.2725 168.286 104.803 168.487C117.333 168.286 129.802 163.409 139.363 153.848C158.895 134.316 158.895 102.648 139.363 83.1167C120.109 63.8628 89.7283 63.63 70.242 83.1167Z",
    fill: "#0055A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.973 83.1164C129.782 71.9254 114.607 67.1496 100.014 68.7828C141.241 73.3965 159.555 124.078 129.785 153.847C121.444 162.188 110.89 166.964 100.014 168.181C114.607 169.814 129.782 165.038 140.973 153.847C160.505 134.315 160.505 102.648 140.973 83.1164Z",
    fill: "#004281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2446 94.119C67.811 107.553 67.811 129.411 81.2446 142.845C87.7571 149.357 96.2497 152.703 104.802 152.901C135.009 152.201 149.733 115.492 128.36 94.1194C115.232 80.9905 94.6392 80.7249 81.2446 94.119V94.119Z",
    fill: "#D8ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.97 94.1195C121.828 85.9777 110.593 82.7796 100.013 84.507C127.6 89.0109 138.585 123.042 118.782 142.845C113.49 148.137 106.89 151.335 100.013 152.457C110.593 154.185 121.828 150.987 129.97 142.845C143.404 129.412 143.404 107.553 129.97 94.1195Z",
    fill: "#B3DAFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_10419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.73e31bc47cd48ad853157e11799bfa50.svg";
export { ForwardRef as ReactComponent };